<template>
    <div class="row mx-2 my-3 pricelist-settings">
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-12 col-md-7">
                    <h3>Order Limit Settings</h3>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    
                </div>
                <div class="col-sm-12 col-md-2 text-right">
                    
                </div>
            </div>

            <div class="row my-5 mx-1 py-2" style="background-color: #e5e5e5;">
                <div class="col-sm-8">
                    <h3 class="m-0">All Locations (Default)</h3>
                </div>
                <div class="col-sm-2">
                    <h3 class="m-0">Max Lines {{ max_order }}</h3>
                </div>
                <div class="col-sm-2">
                    <div class="d-flex align-items-center">
                        <input
                            type="number"
                            v-model="max_order_update"
                            name="max_order"
                            class="form-control mr-3"
                        />
                        <button
                            @click="updateOrderLimit(false)"
                            type="button"
                            class="btn btn-outline-speq text-speq text-uppercase"
                        >
                            Update
                        </button>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 col-md-7"></div>
                <div class="col-sm-12 col-md-3 text-right"></div>
                <div class="col-sm-12 col-md-2 text-right">
                    <span
                        v-if="user.role.id == 1"
                        class="add-button btn btn-action"
                        @click="openModal(null, 'add', false)"
                    >
                        <i
                            class="fa fa-plus-circle"
                            aria-hidden="true"
                        ></i>
                        ADD CUSTOM RULE
                    </span>
                </div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <!-- <th>User</th> -->
                        <th>Dealer</th>
                        <th style="width: 8em">Max Lines</th>
                        <th style="width: 25em"></th>
                        <th style="width: 8em"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="orderLimitSetting in paginatedOrderLimitSettings" :key="orderLimitSetting.id">
                        <td>
                            {{ orderLimitSetting.location?.name }}
                        </td>
                        <td class="text-center">{{ orderLimitSetting.max_order }}</td>
                        <td>
                            <div class="row align-items-center">
                                <div class="col-auto">
                                    <input
                                        type="number"
                                        v-model="orderLimitSetting.max_order_update"
                                        name="maxOrderUpdate"
                                        class="form-control"
                                    />
                                </div>
                                <div class="col-auto">
                                    <button
                                        @click="updateOrderLimit(orderLimitSetting)"
                                        type="button"
                                        class="btn btn-outline-speq text-speq text-uppercase"
                                    >
                                        UPDATE
                                    </button>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span class="px-2 view-action font-weight-bold" @click="deleteOrderLimitSetting(orderLimitSetting)">TRASH</span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Pagination -->
            <table-pagination
                v-model="paginatedOrderLimitSettings"
                :all-rows="searchAllOrderLimitSettingsbyTerm"
                :perPage="perPage"
                @updateRow="updateRow"
            >
            </table-pagination>

        </div>

        <!-- Confirmation modal -->
        <b-modal
            v-model="modalShow"
            :title="modalType == 'add' ? 'ADD CUSTOM RULE' : 'EDIT CUSTOM RULE'"
            hide-footer
        >
            <SpeqOrderLimitSettingModal
                v-if="modalShow"
                :modal-data="modalData"
                :modal-type="modalType"
                :modal-setting="modalSetting"
                @close-modal="closeModal"
            />
        </b-modal>

    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import TablePagination from "@/components/TablePagination.vue";

import SpeqOrderLimitSettingModal from "@/components/speq/modals/SpeqOrderLimitSettingModal.vue";


export default {
    props: [],
    emits: [],
    components: {
        TablePagination,
        SpeqOrderLimitSettingModal,
    },
    setup() {
        const store = useStore();
        const route = useRoute();

        let user = computed(function () {
            return store.state.user;
        });

        let maxOrder = computed(function () {
            return store.state["orderLimit"].maxOrder;
        });

        let allOrderLimitSettings = computed(function () {
            return store.state["orderLimit"].allOrderLimitSettings;
        });

        function getAllOrderLimitSettings() {
            store.dispatch("orderLimit/getAllOrderLimitSettings");
        }

        onMounted(() => {});

        return {
            store,
            route,
            user,
            maxOrder,
            allOrderLimitSettings,
            getAllOrderLimitSettings
        };
    },
    data() {
        return {
            paginatedOrderLimitSettings: [],
            perPage: 50,
            searchTerm: "",
            modalShow: false,
            modalType: null,
            modalSetting: null,
            modalData: {},
            max_order: 0,
            max_order_update: 0,
        };
    },
    computed: {
        searchAllOrderLimitSettingsbyTerm() {
            if (this.searchTerm === "") {
                return this.allOrderLimitSettings;
            }

            var filterArr = [];

            if (this.searchTerm !== "") {
                this.allOrderLimitSettings.forEach((item) => {
                    if (
                        item.location.name
                            .toLowerCase()
                            .includes(this.searchTerm.toLowerCase())
                    ) {
                        filterArr.push(item);
                    }
                });
            }

            return filterArr;
        },
    },
    mounted() {
        this.populateData()
    },
    methods: {
        updateRow(val) {
            this.paginatedOrderLimitSettings = val;
        },
        openModal(data, type, defaultSetting) {
            this.modalType = type;
            this.modalData = data;
            this.modalSetting = defaultSetting;
            this.modalShow = !this.modalShow;
        },
        closeModal() {
            this.modalShow = !this.modalShow;
            this.populateData();
        },
        populateData() {
            this.getAllOrderLimitSettings();
            this.store.dispatch("orderLimit/getOrderLimit").then(resp => {
                this.max_order = this.maxOrder
            });
        },
        updateOrderLimit(orderLimit) {

            if (orderLimit) {
                let request = {
                    location_id: orderLimit.location.id,
                    max_order: orderLimit.max_order_update,
                }

                this.store.dispatch("orderLimit/updateOrderLimitSetting", request).then(resp => {
                    window.emitter.emit("alertSuccess", {
                        message: "Done updating the custom rule.",
                    });
                });

            } else {
                let request = {
                    location_id: 0,
                    max_order: this.max_order_update,
                }

                this.store.dispatch("orderLimit/updateOrderLimitSetting", request).then(resp => {
                    this.max_order = this.max_order_update;
                    this.max_order_update = 0;
                    window.emitter.emit("alertSuccess", {
                        message: "Done updating the default custom rule.",
                    });
                });

            }
        },
        deleteOrderLimitSetting(orderLimit) {
            let request = {
                location_id: orderLimit.location.id,
            }

            this.store.dispatch("orderLimit/deleteOrderLimitSetting", request).then(resp => {
                window.emitter.emit("alertSuccess", {
                    message: "Done deleting the custom rule.",
                });
            });
        }
    },
};
</script>
